import * as React from 'react';
import { TournamentMatchSource, TournamentStructureMatch } from 'Src/models/tournament';
import { BRACKET_ROUNDS } from './tournamentStructureFixtures';
import { SchoolMark } from './TournamentStructureWorkspace';

interface Props {
  matches: TournamentStructureMatch[];
  label: (source: TournamentMatchSource) => string;
  team: (source: TournamentMatchSource) => { name: string; pic?: string } | undefined;
  edit: (id: string) => void;
}
export const TournamentKnockoutBracket: React.FC<Props> = ({ matches, label, team, edit }) => {
  const rounds = [
    ...BRACKET_ROUNDS.slice(0, 2),
    { id: 'ROUND_OF_8', label: 'Round of 8' },
    ...BRACKET_ROUNDS.slice(2),
    { id: 'PLAYOFF', label: 'Placing matches' }
  ].filter(round => matches.some(match => match.round === round.id));
  return (
    <div className="tswKnockoutScroll" aria-label="Knockout bracket">
      <div className="tswKnockout">
        {rounds.map(round => (
          <section key={round.id}>
            <h3>{round.label}</h3>
            <div>
              {matches
                .filter(match => match.round === round.id)
                .map(match => (
                  <button
                    type="button"
                    className={match.removed ? 'is-removed' : ''}
                    key={match.id}
                    onClick={() => edit(match.id!)}
                  >
                    <small>
                      {match.custom
                        ? match.name
                        : match.startTime
                        ? new Date(match.startTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
                        : 'Time not set'}
                      {match.removed ? ' · Removed' : ''}
                    </small>
                    {[match.homeSource, match.awaySource].map((source, index) => {
                      const school = team(source);
                      return (
                        <span key={index}>
                          {school && <SchoolMark name={school.name} pic={school.pic} />}
                          <span>{label(source)}</span>
                        </span>
                      );
                    })}
                  </button>
                ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};
